<script lang="tsx">
  import { defineComponent, PropType } from 'vue'
  import { BeerStyleObj } from '@xhs/yam-beer/core'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import initStyle from './style'

  initStyle()

  /**
   * 简单的卡片样式，一般在画板上使用的 section 容器
   * - 圆角，阴影，间距处理
   *
   * <NewBsBox :bs="{ cmp: 'panle' }" /> 可以达到同样效果
   *
   * 常见情况可以传入 BS 覆盖间距
   */
  export default defineComponent({
    name: 'Panel',
    props: {
      /**
       * 容器 bs style
       * @ignore
       */
      bs: {
        type: Object as PropType<BeerStyleObj>,
        default: () => ({}),
      },
    },
    setup(props, { attrs, slots }) {
      return () => (
          <NewBsBox
            bs={{
              cmp: 'panel',
              ...props.bs,
            }}
            {...attrs}
            v-slots={slots}
          />
        )
    },
  })

</script>
